<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.5 2.16512L3.5 2.16999C2.675 2.16999 2 2.84499 2 3.66999V14.3349C2 15.1599 2.675
        15.8349 3.5 15.8349L14.5 15.83C15.3327 15.83 16 15.1551 16 14.33V3.66512C16 2.83511 15.33
        2.16512 14.5 2.16512ZM14.5014 3.66512L3.49878 3.66999V14.33L14.5014 14.3251V3.66512Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.27319 14.7069L6.27319 3.32135L7.77319 3.32135L7.77319 14.7069L6.27319 14.7069Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2639 14.6932L10.2639 3.30772L11.7639 3.30772L11.7639 14.6932L10.2639 14.6932Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5108 7.48325H2.4895V5.98325H15.5108V7.48325Z"
      fill="#A2B1C6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5108 11.6056H2.4895V10.1056H15.5108V11.6056Z"
      fill="#A2B1C6"
    />
  </svg>
</template>

<script>

export default {
  name: 'TableIcon'
}
</script>
